import type { WalkthroughEvent } from '@shared-types/frontend-scenario-definition';

export const participantActivityWalkthrough: WalkthroughEvent = {
    key: 'participant-activity-walkthrough',
    showAt: 'start',
    steps: [
        {
            id: '0',
            element: { selector: '[data-tour=activity-intro]' },
            text: 'app.courses.activity.tour.activityIntro',
        },
        {
            id: '1',
            element: { selector: '[data-tour=activity-resources]' },
            text: 'app.courses.activity.tour.activityResources',
        },
        {
            id: '2',
            element: { selector: '[data-tour=activity-area]' },
            text: 'app.courses.activity.tour.activityArea',
        },
        {
            id: '3',
            element: { selector: '[data-tour=activity-submit]' },
            text: 'app.courses.activity.tour.activitySubmit',
        },
        {
            id: '4',
            element: { selector: '[data-tour=exit-activity]' },
            text: 'app.courses.activity.tour.exitActivity',
        },
    ],
};

export default participantActivityWalkthrough;
